// Module
var code = "<h2 id=\"postpone-payments-eligibility-quiz\">Postpone Payments Eligibility Quiz</h2> <p>Find out if your federal student loans are eligible for a deferment or forbearance and review the best options for postponing your payments.</p> ";
// Exports
export default code;